import { Component } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";
import {
  ActivityNote,
  ActivityNoteDisplay,
} from "src/app/core/models/activity-notes.model";
import { ActivityNotesService } from "src/app/core/services/activity-notes.service";

@Component({
  selector: "app-update-activity-note",
  templateUrl: "./update-activity-note.component.html",
  styleUrls: ["./update-activity-note.component.scss"],
})
export class UpdateActivityNoteComponent {
  activityNote: ActivityNoteDisplay;
  loggedInUserName: string;
  isSaving: boolean;
  onClose: Subject<ActivityNote>;
  constructor(
    public bsModalRef: BsModalRef,
    private readonly _activityService: ActivityNotesService) {
    this.onClose = new Subject();
  }
  updateNote() {
    this.isSaving = true;
    this._activityService
      .updateActivityNote(this.activityNote.id, {
        patientId: this.activityNote.patientId,
        procedureId: this.activityNote.procedureId,
        encounterId: this.activityNote.encounterId,
        selectedDate: this.activityNote.selectedDate,
        notes: this.activityNote.notes,
        activityBy: this.loggedInUserName,
        activityType: "Manual",
      })
      .subscribe({
        next: (activityNote: ActivityNote) => {
          this.onClose.next(activityNote);
          this.bsModalRef.hide();
        },
        error: (err) => {
},
      })
      .add(() => (this.isSaving = false));
  }
}
